import React from "react";
import {
  CommentOutlined,
  ProjectOutlined,
  SettingOutlined,
  ShopOutlined,
  TagsOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { isProduction } from "metabase/env";
import RemoteSvg from "metabase/ab/components/RemoteSvg";
import { get } from "lodash";
//public/dashboard/uuid
export const wallet_profile_link =
  "/ab/public/dashboard/Wallet-Profile-fp-c703d415-e1d1-4b20-9cdc-989474e73d8e"; //query: wallet_address
export const user_profile_link =
  "/ab/public/dashboard/f3ee86a3-c7d8-4a0b-838a-b6903b406963"; //query: cohort_title

function getItem(label, key, icon, children, type, disabled = false) {
  return {
    key,
    icon,
    children,
    label,
    type,
    disabled,
  };
}

const calProjectId = (str) => {
  const match = str.match(/\d+/);
  return match ? parseInt(match[0], 10) : null
}
export const fga_menu_data_v2 = (project, user, menu) => {
  const isTestTeamFeature = user?.isTestTeamFeature415 || user?.isTestTeamFeature416
  const hideOtherMenu = (user?.role === "project" && !user?.projectIds?.includes(project.id)) || user?.role === "general"
  const isNotManage = !user?.roles?.find(i => calProjectId(i.roleName) === project?.id && i.role === "Manager")
  let protocolType = project?.protocolType;
  if (project?.nftCollectionAddress?.length > 0) {
    if (protocolType === "GameFi") {
      protocolType = "GameFi_NFT";
    } else {
      protocolType = "NFT";
    }
  }

  const dashboardMap = new Map([
    [
      "home",
      protocolType === "NFT"
        ? "346f0d3d-5486-404b-a5d2-17ce52150fe1"
        : "2f4f1fe9-7163-4ecf-91db-76c87a9306ed",
    ],
    [ "game_tokenomics", "70018d58-83e4-4484-b089-15cf327d3974" ],
    [ "game_revenue", "8932389c-42cc-4ce7-a20f-a6a146cd31a2" ],
    [ "game_token_holder", "ff4ddbe9-8818-4abf-8a6c-91c3559071af" ],
    [ "users_overview", "6d84b4a6-ceef-4b30-a9ad-b233038fd8d3" ],
    [ "game_active_users", "6d84b4a6-ceef-4b30-a9ad-b233038fd8d3" ],
    [ "nft_leaderboard", "b0ce22de-a4bd-4f46-827c-75463c725fcd" ],
    [ "nft_holder", "9edaeba8-9c3b-4726-b139-73b2ca738c13" ],
    [ "nft_sales_mints", "aefc83f1-ed4b-4dba-a21f-6f85a1de471c" ],
    [ "nft_revenue", "b98b0a6b-64cb-4e09-979d-693040ea3ec9" ],
    [ "twitter", "039ec0b6-f584-43c6-9e6d-79ee445ef476" ],
    [ "discord", "51cf5b36-2d76-4a0f-bb30-d0ccff354cc9" ],
    [ "project_health", "f5c31ad5-259d-4a2b-8e68-346201201486" ],
    [ "social", "0b478d57-59cf-4ba2-b0e0-9873272f13ce" ],
    [ "gaming", "9666f52b-1b05-46f2-b474-fd46f85690ab" ],
    [ "listing", "20ae0361-4a39-4b66-bd56-fb9f012bfd3c" ],
    [ "project_overlap", "1e4539f2-8c5f-4a61-b14e-a23b7324c5a5" ],
    [ "retention", "c91c1a0e-f345-4266-92ef-ac3af52dc342" ],
    [ "acquisition", "a4e922dc-7df7-4c22-b863-4e55ccc59e4c" ],
    [ "members-platform", "d02ef1f2-bd0a-4ce0-a609-6322b47778aa" ],
    [ "user_profile", "b81a1fe1-2096-4e5e-9c45-4597363bd5c2" ],
    [ "nft_summary", "c8c7d1fa-5250-4727-8f8b-f974e694d19d" ],
    [ "gaming_user", "f869c15e-fc6b-4b64-8f45-2e6b2afab177" ],
    [ "gaming_spend", "3b11a273-5253-45fb-b7ab-7ec81b94a1ab" ],
    [ "gaming_engagement", "8e909c41-14cd-4ab9-9909-92b77281139d" ],
    [ "platform-revenue-user-growth", "67ccb519-dac8-4bee-9308-aadada8c6fa2" ],
    [ "platform-user-engagement", "ab0d4417-46e2-4e81-93bf-c03e00b0dde2" ],
    [ "monetization", "acdfda07-f9d9-42a8-af97-e5a866582c4f" ],
    [ "user-acquisition", "ba290d22-a957-4419-be1c-9e6eae483f8d" ],
    [ "user-engagement", "cfecef3d-2550-4ab3-ab86-809b17f3fa1f" ],
    [ "user-retention", "4bd74bd9-671d-486a-94a6-6234b3436c61" ],
    [ "platform-asset-nft", "00a27792-5fd4-4656-90b0-0face04f1f47" ],
    [ "platform-asset-token", "6c4f2b31-d506-4944-80de-ce6737a5d7ca" ],
    [ "token_holder", "096449c7-3c62-4bfa-8cd7-1b85c2e39c22" ],
    [ "token_trading", "1f516dc7-4769-4956-b0c7-896fbcc1fc1a" ],
    [ "token_leader_board", "7c2c9738-0899-4443-97f9-9c7657383540" ],
    [ "nft_traits", "e04b84a2-e569-49cb-8653-4b9a4679f934" ],
    [ "wallet_profile", "334b2c60-317b-4327-bdb4-c21884e1be6c" ],
    [ "nft_primary_sales", "baefb88b-6234-4086-807b-ae57d3aa4611" ],


    [ "project_health-platform", "79b4c0c1-bc0d-4fde-ba2d-8e7bc9b0ea18" ],
    [ "users_overview-platform", "6d84b4a6-ceef-4b30-a9ad-b233038fd8d3" ],
  ]);

  const platformMenuTabs = [
    getItem("Asset", "platform-asset", <img width={16} height={16}
                                            src={"https://static.footprint.network/fga/ab/assets.png"}/>, [
      getItem("NFT", "platform-asset-nft", null),
      getItem("Token", "platform-asset-token", null),
    ]),
    getItem("Platform", "platform-platform", <img width={16} height={16}
                                                  src={"https://static.footprint.network/fga/ab/community.png"}/>, [
      getItem("Revenue & User Growth", "platform-revenue-user-growth", null),
    ]),
  ];

  const liveKeys = [
    "home_nft",
    "home_game",
    "nft_nft_holder",
    "nft_leaderboard",
    "nft_sales_mints",
    "game_tokenomics",
    "game_token_holder",
    "game_active_users",
    "game_revenue",
    "nft_revenue",
  ];

  const getIcon = (icon) => {
    if (!icon) {
      return null
    }
    if (icon?.endsWith(".svg")) {
      return <RemoteSvg width={20} height={20} url={icon}/>
    }
    return <img src={icon} width={20} height={20}/>
  }

  const getlabel = (object) => {
    return (<div className="flex items-center" style={{ gap: 4 }}>{object.title}{get(object, "tags.[0]") &&
      <div className="ab__flag-new">{get(object, "tags.[0]")}</div>}</div>)
  }
  const menus = menu || project?.menu
  const menuTabs2 = menus?.map(i => {
    return {
      key: i.value,
      label: getlabel(i),
      // icon: <MyIcon src={i.icon}/>,
      icon: getIcon(i.icon),
      type: i.mode,
      children: i.children?.map(j => {
        return {
          key: j.value,
          label: getlabel(j),
          type: j.mode,
          icon: getIcon(j.icon),
          children: j.children?.map(k => {
            return {
              key: k.value,
              label: getlabel(k),
              type: k.mode,
              icon: <RemoteSvg width={20} height={20} url={k.icon}/>,
            }
          })?.filter(j => {
            if (isTestTeamFeature) {
              return !([ "settings", "user-config", "dashboard-config", "integration" ]?.includes(j.key) && isNotManage)
            }
            if ([ "user-config", "dashboard-config" ]?.includes(j.key)) {
              return false
            }
            return !([ "integration", "demographics" ]?.includes(j.key) && hideOtherMenu)
          })
        }
      })?.filter(j => {
        if (isTestTeamFeature) {
          return !([ "settings", "user-config", "dashboard-config", "integration" ]?.includes(j.key) && isNotManage)
        }
        if ([ "user-config", "dashboard-config" ]?.includes(j.key)) {
          return false
        }
        return !([ "integration", "demographics" ]?.includes(j.key) && hideOtherMenu)
      })
    }
  })?.filter(i => {
    if (isTestTeamFeature) {
      if (i.mode === 'group' && i.children?.length === 0) {
        return false
      }
      return !([ "settings", "user-config", "dashboard-config", "integration" ]?.includes(i.key) && isNotManage)
    }
    if ([ "user-config", "dashboard-config" ]?.includes(i.key)) {
      return false
    }
    return !([ "platform", "integration", "demographics" ]?.includes(i.key) && hideOtherMenu)
  }) || []

  let menuTabs3 = [];

  menuTabs2
    ?.filter(i => !(i.type === 'group' && i.children?.length === 0))
    ?.forEach((item, index) => {
      if (item.type === "group" && index !== 0) {
        menuTabs3.push({ "type": "divider", "key": `divider-${index}` });
      }
      menuTabs3.push(item);
    });

  let menuTabs = menuTabs3

  let keys = []
  keys = getKeys([ ...menuTabs, ...platformMenuTabs ]);
  if (menuTabs.length === 0) {
    keys = [ "no-menu" ]
  }
  return { menuTabs, platformMenuTabs, keys, dashboardMap, liveKeys };
};

const getKeys = items => {
  let keys = [];
  items?.map(item => {
    if (item) {
      if (item?.children?.length > 0) {
        keys = keys.concat(getKeys(item.children));
      } else {
        keys.push(item?.key);
      }
    }
  });
  return keys;
};

export const walletGroupList = [ "Players", "Token Holders", "NFT Holders" ]
export const benchmarkList = [ "BTC", "ETH", "GameFi Index" ]

export const ComparedNFTList = [
  {
    "name": "Bored Ape Yacht Club",
    "chain": "Ethereum",
    "address": "0xbc4ca0eda7647a8ab7c2061c2e118a18a936f13d"
  },
  {
    "name": "CryptoPunks",
    "chain": "Ethereum",
    "address": "0xb47e3cd837ddf8e4c57f05d70ab865de6e193bbb"
  },
  {
    "name": "Mutant Ape Yacht Club",
    "chain": "Ethereum",
    "address": "0x60e4d786628fea6478f785a6d7e704777c86a7c6"
  },
  {
    "name": "Azuki",
    "chain": "Ethereum",
    "address": "0xed5af388653567af2f388e6224dc7c4b3241c544"
  },
  {
    "name": "Otherdeed for Otherside",
    "chain": "Ethereum",
    "address": "0x34d85c9cdeb23fa97cb08333b511ac86e1c4e258"
  },
  {
    "name": "CLONE X - X TAKASHI MURAKAMI",
    "chain": "Ethereum",
    "address": "0x49cf6f5d44e70224e2e23fdcdd2c053f30ada28b"
  },
  {
    "name": "Pudgy Penguins",
    "chain": "Ethereum",
    "address": "0xbd3531da5cf5857e7cfaa92426877b022e612cf8"
  },
  {
    "name": "Moonbirds",
    "chain": "Ethereum",
    "address": "0x23581767a106ae21c074b2276d25e5c3e136a68b"
  },
  {
    "name": "Doodles",
    "chain": "Ethereum",
    "address": "0x8a90cab2b38dba80c64b7734e58ee1db38b8992e"
  },
  {
    "name": "Wrapped Cryptopunks",
    "chain": "Ethereum",
    "address": "0xb7f7f6c52f2e2fdb1963eab30438024864c313f6"
  },
  {
    "name": "Bored Ape Kennel Club",
    "chain": "Ethereum",
    "address": "0xba30e5f9bb24caa003e9f2f0497ad287fdf95623"
  },
  {
    "name": "Meebits",
    "chain": "Ethereum",
    "address": "0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7"
  },
  {
    "name": "BEANZ Official",
    "chain": "Ethereum",
    "address": "0x306b1ea3ecdf94ab739f1910bbda052ed4a9f949"
  },
  {
    "name": "Cool Cats",
    "chain": "Ethereum",
    "address": "0x1a92f7381b9f03921564a437210bb9396471050c"
  },
  {
    "name": "Milady Maker",
    "chain": "Ethereum",
    "address": "0x5af0d9827e0c53e4799bb226655a1de152a425a5"
  },
  {
    "name": "Loot (for Adventurers)",
    "chain": "Ethereum",
    "address": "0xff9c1b15b16263c61d017ee9f65c50e4ae0113d7"
  },
  {
    "name": "DeGods",
    "chain": "Ethereum",
    "address": "0x8821bee2ba0df28761afff119d66390d594cd280"
  },
  {
    "name": "Memeland Captainz",
    "chain": "Ethereum",
    "address": "0x769272677fab02575e84945f03eca517acc544cc"
  },
  {
    "name": "CrypToadz by GREMPLIN",
    "chain": "Ethereum",
    "address": "0x1cb1a5e65610aeff2551a50f76a87a7d3fb649c6"
  },
  {
    "name": "World of Women",
    "chain": "Ethereum",
    "address": "0xe785e82358879f061bc3dcac6f0444462d4b5330"
  },
  {
    "name": "ENS: Ethereum Name Service",
    "chain": "Ethereum",
    "address": "0xd4416b13d2b3a9abae7acd5d6c2bbdbe25686401"
  },
  {
    "name": "ENS: Ethereum Name Service",
    "chain": "Ethereum",
    "address": "0x57f1887a8bf19b14fc0df6fd9b2acc9af147ea85"
  },
  {
    "name": "0N1 Force",
    "chain": "Ethereum",
    "address": "0x3bf2922f4520a8ba0c2efc3d2a1539678dad5e9d"
  },
  {
    "name": "CyberKongz",
    "chain": "Ethereum",
    "address": "0x57a204aa1042f6e66dd7730813f4024114d74f37"
  },
  {
    "name": "Bored Ape Chemistry Club",
    "chain": "Ethereum",
    "address": "0x22c36bfdcef207f9c0cc941936eff94d4246d14a"
  },
  {
    "name": "Chromie Squiggle by Snowfro",
    "chain": "Ethereum",
    "address": "0x059edd72cd353df5106d2b9cc5ab83a52287ac3a"
  },
  {
    "name": "Lil Pudgys",
    "chain": "Ethereum",
    "address": "0x524cab2ec69124574082676e6f654a18df49a048"
  },
  {
    "name": "PUNKS Comic",
    "chain": "Ethereum",
    "address": "0x66d1db16101502ed0ca428842c619ca7b62c8fef"
  },
  {
    "name": "PUNKS Comic",
    "chain": "Ethereum",
    "address": "0xb716600ed99b4710152582a124c697a7fe78adbf"
  },
  {
    "name": "PUNKS Comic",
    "chain": "Ethereum",
    "address": "0x0bebad1ff25c623dff9605dad4a8f782d5da37df"
  },
  {
    "name": "PUNKS Comic",
    "chain": "Ethereum",
    "address": "0x5ab21ec0bfa0b29545230395e3adaca7d552c948"
  },
  {
    "name": "PUNKS Comic",
    "chain": "Ethereum",
    "address": "0xd0a07a76746707f6d6d36d9d5897b14a8e9ed493"
  },
  {
    "name": "PUNKS Comic",
    "chain": "Ethereum",
    "address": "0x797a48c46be32aafcedcfd3d8992493d8a1f256b"
  },
  {
    "name": "PUNKS Comic",
    "chain": "Ethereum",
    "address": "0x128675d4fddbc4a0d3f8aa777d8ee0fb8b427c2f"
  },
  {
    "name": "VeeFriends",
    "chain": "Ethereum",
    "address": "0xa3aee8bce55beea1951ef834b99f3ac60d1abeeb"
  },
  {
    "name": "Fidenza by Tyler Hobbs",
    "chain": "Ethereum",
    "address": "0xa7d8d9ef8d8ce8992df33d8b8cf4aebabd5bd270"
  },
  {
    "name": "MekaVerse",
    "chain": "Ethereum",
    "address": "0x9a534628b4062e123ce7ee2222ec20b86e16ca8f"
  }
]

export const ComparedTokenList = [
  {
    "name": "DOGE",
    "chain": "BNB Chain",
    "address": "0xba2ae424d960c26247dd6c32edc70b295c744c43"
  },
  {
    "name": "TON",
    "chain": "Ethereum",
    "address": "0x582d872a1b094fc48f5de31d3b73f2d9be47def1"
  },
  {
    "name": "TON",
    "chain": "BNB Chain",
    "address": "0x76a797a59ba2c17726896976b7b3747bfd1d220f"
  },
  {
    "name": "SHIB",
    "chain": "Ethereum",
    "address": "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce"
  },
  {
    "name": "LINK",
    "chain": "Ethereum",
    "address": "0x514910771af9ca656af840dff83e8264ecf986ca"
  },
  {
    "name": "LINK",
    "chain": "BNB Chain",
    "address": "0xf8a0bf9cf54bb92f17374d9e9a321e6a111a51bd"
  },
  {
    "name": "LINK",
    "chain": "Polygon",
    "address": "0x53e0bca35ec356bd5dddfebbd1fc0fd03fabad39"
  },
  {
    "name": "LEO",
    "chain": "Ethereum",
    "address": "0x2af5d2ad76741191d15dfe7bf6ac92d4bd912ca3"
  },
  {
    "name": "UNI",
    "chain": "Ethereum",
    "address": "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984"
  },
  {
    "name": "UNI",
    "chain": "Polygon",
    "address": "0xb33eaad8d922b1083446dc23f610c2567fb5180f"
  },
  {
    "name": "UNI",
    "chain": "BNB Chain",
    "address": "0xbf5140a22578168fd562dccf235e5d43a02ce9b1"
  },
  {
    "name": "NEAR",
    "chain": "Ethereum",
    "address": "0x85f17cf997934a597031b2e18a9ab6ebd4b9f6a4"
  },
  {
    "name": "PEPE",
    "chain": "Ethereum",
    "address": "0x6982508145454ce325ddbe47a25d4ec3d2311933"
  },
  {
    "name": "PEPE",
    "chain": "BNB Chain",
    "address": "0x25d887ce7a35172c62febfd67a1856f20faebb00"
  },
  {
    "name": "FET",
    "chain": "Ethereum",
    "address": "0xaea46a60368a7bd060eec7df8cba43b7ef41ad85"
  },
  {
    "name": "FET",
    "chain": "BNB Chain",
    "address": "0x031b41e504677879370e9dbcf937283a8691fa7f"
  },
  {
    "name": "OKB",
    "chain": "Ethereum",
    "address": "0x75231f58b43240c9718dd58b4967c5114342a86c"
  },
  {
    "name": "AAVE",
    "chain": "Ethereum",
    "address": "0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9"
  },
  {
    "name": "AAVE",
    "chain": "Polygon",
    "address": "0xd6df932a45c0f255f85145f286ea0b292b21c90b"
  },
  {
    "name": "AAVE",
    "chain": "BNB Chain",
    "address": "0xfb6115445bff7b52feb98650c87f44907e58f802"
  }
]
